import { CancellationPolicy } from '../models';
import { CancellationPolicyPeriod } from '../enums';

export function getCancellationPolicyWindowInMilliseconds(data: CancellationPolicy): number {
  let periodInMilliseconds = data.time * 60 * 60 * 1000;
  if (data.period === CancellationPolicyPeriod.days) {
    periodInMilliseconds *= 24;
  }

  return periodInMilliseconds;
}
